export default {
  actualSetpoint: 'Aktualna nastawa',
  actualValue: 'Aktualna wartość',
  copySetpointsFromRecipe: 'Skopiuj punkty nastawy z receptury',
};
